// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ywu5","placeholdersHeader":"styles_placeholdersHeader__iF2nx","editorStyle":"styles_editorStyle__3_PF6","placeholdersBox":"styles_placeholdersBox__3w1WQ"};